function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 28.845c0-.805.647-1.458 1.446-1.458H26.89c.799 0 1.446.653 1.446 1.458v16.697c0 .805-.647 1.458-1.446 1.458H2.446A1.452 1.452 0 011 45.542v-3.318a.657.657 0 011.314 0v3.318c0 .073.06.133.132.133H26.89c.073 0 .132-.06.132-.133V28.845a.132.132 0 00-.132-.133H2.446a.132.132 0 00-.132.133v10.077a.657.657 0 01-1.314 0V28.844z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.306 23.121a1.428 1.428 0 011.082-.504h16.56c.451 0 .83.212 1.083.503l.005.006 3.966 4.785-1.008.85-3.955-4.772a.165.165 0 00-.048-.037.092.092 0 00-.043-.01H6.388a.092.092 0 00-.041.01.16.16 0 00-.048.037L2.343 28.76l-1.008-.85 3.966-4.785.005-.005zM14.668 31.893c-2.903 0-5.257 2.373-5.257 5.3 0 2.928 2.354 5.301 5.257 5.301 2.904 0 5.257-2.373 5.257-5.3 0-2.928-2.354-5.301-5.257-5.301zm-6.571 5.3c0-3.659 2.942-6.625 6.571-6.625 3.63 0 6.572 2.966 6.572 6.625 0 3.66-2.943 6.626-6.572 6.626-3.63 0-6.571-2.966-6.571-6.626z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.361 35.06a.667.667 0 010 .937L14.74 39.65a.655.655 0 01-.93 0l-2.029-2.046a.666.666 0 010-.937.653.653 0 01.93 0l1.564 1.577 3.158-3.184a.653.653 0 01.93 0zM41.994 17.276a1.406 1.406 0 011.3-.888c.18 0 .338.05.407.073l.011.004.006.001 2.333.79a1.422 1.422 0 01.846 1.875v.001l-10.002 25.7-3.999 2.035-1.01-4.114 10.108-25.477zm1.182.495v.001l-9.95 25.075.524 2.131 2.137-1.087 9.822-25.24.001-.002a.137.137 0 00.012-.049.106.106 0 00-.021-.066.144.144 0 00-.066-.048l-2.31-.781a1.575 1.575 0 00-.037-.012l-.01-.003a.13.13 0 00-.102.08z",
  fill: "#2D2D2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.057 20.174a.655.655 0 01.846-.388l3.804 1.44c.34.129.512.51.384.853a.656.656 0 01-.846.388l-3.804-1.44a.664.664 0 01-.384-.853zM34.857 13.86a.666.666 0 01.24.905l-1.914 3.344a.657.657 0 01-.898.243l-1.857-1.081a.666.666 0 01-.24-.906.654.654 0 01.897-.242l1.288.75 1.587-2.77a.654.654 0 01.897-.243z",
  fill: "#2D2D2D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.037 10.883a1.326 1.326 0 01.93-1.623l2.63-.71.34 1.28-2.63.71L15.1 21.054a.66.66 0 01-.466.806.654.654 0 01-.804-.464l-2.794-10.513zM35.52 4.27l-.877.227a.653.653 0 01-.792-.45.66.66 0 01.46-.82l.87-.237c.7-.19 1.421.23 1.609.937l4.713 17.734-1.27.343L35.52 4.268zm8.407 31.634l-1.996-7.511 1.27-.343 1.996 7.511a1.326 1.326 0 01-.93 1.623l-3.116.95a.654.654 0 01-.672-.182.66.66 0 01.292-1.075l3.156-.973zm-16.302 4.405l6.118-1.653.34 1.28-6.118 1.653-.34-1.28z",
  fill: "#2D2D2D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.864 8.356a1.326 1.326 0 01.93-1.623l16.685-4.508c.7-.19 1.421.23 1.61.937l.971 3.657a1.326 1.326 0 01-.93 1.623L16.447 12.95a1.313 1.313 0 01-1.61-.937l-.972-3.657zM31.82 3.505L15.134 8.013l.972 3.657L32.79 7.162l-.972-3.657zM16.782 16.778a.663.663 0 01.465-.811l17.5-4.728a.663.663 0 01.34 1.28l-17.5 4.728a.657.657 0 01-.805-.469zM17.657 20.07a.663.663 0 01.465-.812l9.34-2.523a.663.663 0 01.34 1.28l-9.34 2.523a.657.657 0 01-.805-.468zM13.073 20.855c0 .272-.203.492-.455.492H9.585c-.25 0-.455-.22-.455-.492 0-.271.204-.491.455-.491h3.033c.252 0 .455.22.455.491zM8.625 20.855a.49.49 0 01-.487.492H6.745a.49.49 0 01-.488-.492.49.49 0 01.488-.491h1.393c.269 0 .487.22.487.491z",
  fill: "#2D2D2D"
});

function SvgStockControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "/img/stock-control.svg";
export { SvgStockControl as ReactComponent };